import {
  BrowseViewResponseDto,
  ApiError,
  ErrorResponseDto,
  BrowseViewState,
} from '@pro4-erp/core-web';
import { Reminder } from '../types/reminder';
import env from '@/env';

type ReminderType = 'ToBeReviewed' | 'Ended';

type GetRemindersForMeParams = BrowseViewState & {
  reminderType?: ReminderType;
};

export const getRemindersForMe = async ({
  page,
  pageSize,
  search,
  sortBy,
  reminderType,
}: GetRemindersForMeParams): Promise<BrowseViewResponseDto<Reminder>> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/reminders/me?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
      sortBy: JSON.stringify(sortBy) || '',
      reminderType: reminderType || 'ToBeReviewed',
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as BrowseViewResponseDto<Reminder>;
  return response;
};
